var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationOutlined = function SvgLocationOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.342,
    height: 60
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 546",
    fill: "#376996"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 228",
    d: "M22.171 0A22.2 22.2 0 0 0-.003 22.171c0 11.836 20.212 36.279 21.072 37.314a1.429 1.429 0 0 0 2.2 0c.861-1.035 21.072-25.478 21.072-37.314A22.2 22.2 0 0 0 22.171 0Zm0 56.3c-1.792-2.238-5.516-7.006-9.2-12.457C6.354 34.061 2.857 26.566 2.857 22.171a19.314 19.314 0 0 1 38.627 0c0 4.394-3.5 11.89-10.113 21.677-3.685 5.452-7.408 10.218-9.2 12.452Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 229",
    d: "M29.856 38.222a1.616 1.616 0 0 0-2.244.435 210.635 210.635 0 0 1-7.263 10.059 1.616 1.616 0 1 0 2.567 1.965c2.677-3.5 5.158-6.932 7.375-10.214a1.616 1.616 0 0 0-.435-2.245Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 230",
    d: "M22.171 10.03c-5.701 0-10.339 5.946-10.339 13.255S16.47 36.54 22.171 36.54 32.51 30.594 32.51 23.285 27.872 10.03 22.171 10.03Zm0 23.277c-4.311 0-7.817-4.5-7.817-10.022s3.507-10.022 7.817-10.022 7.817 4.5 7.817 10.022-3.506 10.022-7.817 10.022Z"
  })))));
};
export default SvgLocationOutlined;